import FiltersMenu from "./filters-menu";

export default FiltersMenu;